import { render, staticRenderFns, recyclableRender, components } from "./countdown-presale.vue?vue&type=template&id=09b3ecf6&"
var renderjs
import script from "./countdown-presale.vue?vue&type=script&lang=js&"
export * from "./countdown-presale.vue?vue&type=script&lang=js&"
import style0 from "./countdown-presale.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!E:\\HBuilderX\\plugins\\uniapp-cli\\node_modules\\@dcloudio\\vue-cli-plugin-uni\\packages\\vue-loader\\lib\\runtime\\componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null,
  false,
  components,
  renderjs
)

component.options.__file = "components/countdown/countdown-presale.vue"
export default component.exports